/** @format */
import React, { useEffect } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { privateRoutes, publicRoutes, RouterType } from "./routes";
import NotFound from "pages/404/Notfound";
import { useApp, useKey, useUser } from "hooks";
import { KEY_CONTEXT, ROUTES } from "utils";

const RequireAuth = () => {
  const { getKey } = useKey();
  const { onUpdateParams, taskDetailIsFetch } = useApp()
  const accessToken = getKey(KEY_CONTEXT.ACCESS_TOKEN);
  const isLogged = useUser(state => state.profile);
  const { setProfile, setToken, token } = useUser();
  useEffect(() => {
    if (!accessToken && isLogged) {
      setProfile(null);
    }
  }, [accessToken, isLogged])

  useEffect(() => {
    if (accessToken !== token) {
      console.log("🚀 ~ RequireAuth ~ accessToken !== token:", accessToken !== token)
      setToken(accessToken);
      if (accessToken) {
        onUpdateParams({ taskDetailIsFetch: !taskDetailIsFetch })
      }
    }
  }, [accessToken, token])

  return !!isLogged ? <Outlet /> : <Navigate to={ROUTES.PUBLIC_URL.LOGIN} />;
};

function App() {
  return (
    <React.Suspense fallback={<></>}>
      <Routes>
        <Route element={<RequireAuth />}>
          {privateRoutes.map((route: RouterType, index) => {
            const Layout = route.layout;
            const Component = route.component;
            return (
              <Route
                key={`${index}-${route.path}`}
                path={route.path}
                element={
                  <Layout>
                    <Component />
                  </Layout>
                }
              />
            );
          })}
        </Route>
        {publicRoutes.map((route: RouterType, index) => {
          const Layout = route.layout;
          const Component = route.component;
          return (
            <Route
              key={`${index}-${route.path}`}
              path={route.path}
              element={
                <Layout>
                  <Component />
                </Layout>
              }
            />
          );
        })}
        <Route path={"*"} element={<NotFound />} />
      </Routes>
    </React.Suspense>
  );
}

export default App;
